import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const AgentIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  // style="enable-background:new 0 0 512 512"

  return (
    <svg
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0"
      y="0"
      viewBox="0 0 682.66669 682.66669"
      xmlSpace="preserve"
    >
      <g>
        <defs id="defs1297">
          <clipPath clipPathUnits="userSpaceOnUse" id="clipPath1307">
            <path d="M 0,512 H 512 V 0 H 0 Z" id="path1305" data-original="#000000"></path>
          </clipPath>
        </defs>
        <g id="g1299" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
          <g id="g1301">
            <g id="g1303" clipPath="url(#clipPath1307)">
              <g id="g1309" transform="translate(106.6064,106.6064)">
                <path
                  d="m 0,0 c -5.857,5.857 -15.355,5.857 -21.213,0 -5.858,-5.857 -5.858,-15.355 0,-21.213 l 14.394,-14.393 h -48.787 v 165 c 0,8.284 -6.716,15 -15,15 -8.285,0 -15,-6.716 -15,-15 v -180 c 0,-8.285 6.715,-15 15,-15 H -6.819 L -21.213,-80 c -5.858,-5.857 -5.858,-15.355 0,-21.213 2.929,-2.929 6.768,-4.393 10.607,-4.393 3.838,0 7.677,1.464 10.606,4.393 l 40,40 c 5.858,5.858 5.858,15.356 0,21.213 z"
                  style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                  id="path1311"
                  data-original="#000000"
                ></path>
              </g>
              <g id="g1313" transform="translate(405.3936,345.3936)">
                <path
                  d="m 0,0 c 2.929,-2.929 6.768,-4.394 10.606,-4.394 3.839,0 7.678,1.465 10.607,4.394 5.858,5.857 5.858,15.355 0,21.213 L 6.819,35.606 h 48.787 v -165 c 0,-8.284 6.716,-15 15,-15 8.285,0 15,6.716 15,15 v 180 c 0,8.285 -6.715,15 -15,15 H 6.819 L 21.213,80 c 5.858,5.857 5.858,15.355 0,21.213 -5.858,5.857 -15.356,5.857 -21.213,0 l -40,-40 C -45.858,55.355 -45.858,45.857 -40,40 Z"
                  style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                  id="path1315"
                  data-original="#000000"
                ></path>
              </g>
              <g id="g1317" transform="translate(72.25,282)">
                <path
                  d="m 0,0 h 193.75 c 35.841,0 65,29.159 65,65 0,30.681 -21.369,56.466 -50.004,63.254 C 208.342,170.644 173.733,205 131.25,205 121.24,205 111.405,203.065 102.221,199.337 86.459,218.527 62.746,230 37.5,230 c -46.18,0 -83.75,-37.57 -83.75,-83.75 0,-6.42 0.739,-12.775 2.205,-19.004 C -61.072,113.873 -71.25,93.363 -71.25,71.25 -71.25,31.963 -39.287,0 0,0"
                  style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                  id="path1319"
                  data-original="#000000"
                ></path>
              </g>
              <g id="g1321" transform="translate(460.9961,128.2539)">
                <path
                  d="m 0,0 c -0.404,42.39 -35.013,76.746 -77.496,76.746 -10.01,0 -19.845,-1.934 -29.029,-5.663 -15.762,19.19 -39.475,30.663 -64.721,30.663 -46.18,0 -83.75,-37.57 -83.75,-83.75 0,-6.42 0.739,-12.775 2.205,-19.004 -17.027,-13.373 -27.205,-33.883 -27.205,-55.996 0,-39.287 31.963,-71.25 71.25,-71.25 h 193.75 c 35.841,0 65,29.159 65,65 C 50.004,-32.573 28.635,-6.788 0,0"
                  style={{ fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                  id="path1323"
                  data-original="#000000"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
